module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_online-a58d88df6604a27df9577db819a66348.jpg";